

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface outsidelabmasterParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface outsidelabmaster {
    id?: string;
    name: string;
    shortName:string;
    address:string;
    isActive:boolean;
    
    /*area?:string;
    city:string;
    state:any;
    country:any;
    pincode:string;
    workPhone?:string;*/
    mobile:string;
    altMobile?:string;
    email?:string;
    tenantId:any;
    branchId:any;
    parameters?: outsidelabmasterParameter[];
    links?: any;
}

export abstract class outsidelabmasterData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<outsidelabmaster[]>;
  abstract create(url: string,data: outsidelabmaster): Observable<any>;
  abstract update(url: string,data: outsidelabmaster): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
